<template>
  <v-container fluid>
    <h1 class="text-center my-5">{{ $t("title_PlanIndex") }}</h1>
    <v-row v-blur="blurConfig" align="center" justify="center">
      <p class="mr-3 mt-n1">{{ $t("subtitlePrepend") }}</p>
      <SwisetSelect
        ref="Accounts"
        :label="$t('label_PlanIndex')"
        :placeholder="
          this.$store.state.user.brokerAccounts[0].identifier +
          ' - ' +
          this.$store.state.user.brokerAccounts[0].broker.name
        "
        :options="
          this.$store.state.user.brokerAccounts.map((acc) => ({
            value: Number(acc.id),
            text: `${acc.identifier} - ${acc.broker.name}`,
          }))
        "
        v-model="brokerAccountSelected"
        :changeEvent="accountChanged"
        :type="0"
      >
      </SwisetSelect>
      <p class="ml-3 mt-n1">{{ $t("subtitleAppend") }}</p>
    </v-row>
    <TradingPlan
      v-blur="blurConfig"
      :account-id="Number(this.brokerAccountSelected)"
    />
    <LargeCardAd v-if="ad !== null" :ad="ad" />

    <!-- Overlay for CTA upgrade to pro !-->
    <v-overlay :dark="false" v-model="canSeePlan" absolute opacity="0">
      <UpgradeToPro
        :message="messageUpgradeToPro"
        @closeWindow="seeProAdvantages = false"
      />
    </v-overlay>
  </v-container>
</template>

<script>
import AdEngine from "../../ads/adEngine";

import TradingPlan from "@/views/Plan/components/TradingPlan";
import UpgradeToPro from "@/components/UpgradeToPro";
import LargeCardAd from "@/ads/LargeCardAd";
import SwisetSelect from "../../components/comp-base/SwisetSelect.vue";

export default {
  name: "PlanIndex",
  components: { LargeCardAd, UpgradeToPro, TradingPlan, SwisetSelect },
  data() {
    return {
      // Ads
      ad: null,

      blurConfig: {
        isBlurred: !this.$store.state.user.isPro,
        opacity: 0.1,
        filter: "blur(1.2px)",
        transition: "all .3s linear",
      },
      canSeePlan: !this.$store.state.user.isPro,
      messageUpgradeToPro: this.$t("ctaUpgradeToPro"),

      brokerAccounts: [],
      brokerAccountSelected: 0,
    };
  },
  mounted() {
    this.init();
    let accSelect = this.$refs.Accounts.$el;
    const store = this.$store;
    accSelect.querySelectorAll(".option").forEach(function (el, index) {
      if (index > 1) {
        let identifier = el.textContent.split(" ")[0];
        let pos = store.state.user.brokerAccounts
          .map((e) => e.identifier)
          .indexOf(identifier);
        let isVerified = store.state.user.brokerAccounts[pos].verified;
        if (isVerified) {
          let icon = document.createElement("img");
          icon.src = require("@/assets/icons/Audited.svg");
          icon.alt = "Audited Icon";
          icon.style.position = "absolute";
          icon.style.width = "16px";
          icon.style.height = "16px";
          icon.style.right = 0;
          el.appendChild(icon);
        }
      }
    });
  },
  methods: {
    retrieveAd() {
      this.ad = AdEngine.getRandomAd("Large Ad");
    },
    init() {
      this.retrieveAd();
      this.brokerAccounts = this.$store.state.user.brokerAccounts;
      this.brokerAccountSelected = this.brokerAccounts[0].id;
    },
  },
};
</script>



<style scoped></style>
